// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-favourites-index-wrapper-bxyqw.pages-favourites-index-mobile-bczfr{padding-top:32px}.pages-favourites-index-products-rkevt{position:relative}.pages-favourites-index-productsLoading-ytmya{background:hsla(0,0%,100%,.9);bottom:0;left:0;position:absolute;right:0;top:0}.pages-favourites-index-productsList-brddp{display:grid;grid-gap:24px}.pages-favourites-index-productsList-brddp.pages-favourites-index-desktop-ccirz{grid-template-columns:repeat(6,1fr)}.pages-favourites-index-productsList-brddp.pages-favourites-index-mobile-bczfr{grid-template-columns:repeat(2,1fr)}.pages-favourites-index-loading-byybi{height:100px!important;width:100%!important}.pages-favourites-index-emptyCart-bhyho{font-size:18px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "pages-favourites-index-wrapper-bxyqw",
	"mobile": "pages-favourites-index-mobile-bczfr",
	"products": "pages-favourites-index-products-rkevt",
	"productsLoading": "pages-favourites-index-productsLoading-ytmya",
	"productsList": "pages-favourites-index-productsList-brddp",
	"desktop": "pages-favourites-index-desktop-ccirz",
	"loading": "pages-favourites-index-loading-byybi",
	"emptyCart": "pages-favourites-index-emptyCart-bhyho"
};
module.exports = ___CSS_LOADER_EXPORT___;
